export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_URL || '573425157780562';
export const GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_URL||
  '961240577964-jjrl4bn6pg115n2oq798hhdf351cle7p.apps.googleusercontent.com';

export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://tironem.azurewebsites.net/api';

export const BASE_URL_PREFIX = process.env.REACT_APP_BASE_URL_PREFIX || 'https://tironem.azurewebsites.net';
